import {Collaborator, Owner, OwnerInfo} from 'auth/PermissionConstants';
import EntityStore from 'stores/EntityStore';
import APIUtil from 'util/APIUtil';
import * as net from 'util/Net';
import * as TaskRunner from 'util/TaskRunner';

export interface CreateTemplateParams {
  name: string;
  description?: string;
  owner: Owner;
  collaborators?: Array<Collaborator>;
  ownerInfo: OwnerInfo;
}

export interface BulkArchiveResponse {
  archivedItemIds: Array<string>;
}

export interface BulkUnarchiveResponse {
  unarchivedItemIds: Array<string>;
}

const TemplateCollectionDAO = {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  create({name, description, owner, collaborators, ownerInfo}: CreateTemplateParams) {
    return net.postJSON({
      url: '/1/api/template-collections/',
      data: {name, description, owner: owner.handle, ownerInfo, collaborators},
    });
  },

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  update(id: string, {name, description, owner, collaborators, ownerInfo}: CreateTemplateParams) {
    return net.patchJSON({
      url: `/1/api/template-collections/${id}`,
      data: {name, description, owner: owner.handle, ownerInfo, collaborators},
    });
  },

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  delete(id: string) {
    return net.delete_({url: `/1/api/template-collections/${id}`});
  },

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  fetchCollaborators(id: string) {
    return net.getJSON(`/1/api/template-collections/${id}/collaborators/`);
  },

  collectionsURL(): string {
    return `/${EntityStore.currentUser().url_identifier}/template-collections/`;
  },

  collectionURL(templateCollectionId: string): string {
    const unprefixedId = APIUtil.unprefixApiId(templateCollectionId);
    return `/${EntityStore.currentUser().url_identifier}/template-collections/${unprefixedId}`;
  },

  bulkArchive(ids: Array<string>, purpose: string): Promise<BulkArchiveResponse> {
    return TaskRunner.postJSONPromise({
      url: '/1/api/template-collections:bulk-archive',
      data: {ids, purpose},
    });
  },

  bulkUnarchive(ids: Array<string>): Promise<BulkUnarchiveResponse> {
    return TaskRunner.postJSONPromise({
      url: '/1/api/template-collections:bulk-unarchive',
      data: {ids},
    });
  },
};

export default TemplateCollectionDAO;
